import React from 'react';
// import Helmet from 'react-helmet';

export default function QualifyingFinal() {
  return (
    <>
      {/* <Helmet>
        <title>Draws & Schedule | KIYG Haryana 2021</title>
        <meta
          name="description"
          content="Check the DRAWS & SCHEDULE now! 25 Sports | 4th - 13th June 2022. Watch India's finest U/18 athletes represent their respective states at #KIYG2021!"
        />
        <meta property="og:title" content="Draws & Schedule | KIYG Haryana 2021" />
        <meta
          property="og:description"
          content="Check the DRAWS & SCHEDULE now! 25 Sports | 4th - 13th June 2022. Watch India's finest U/18 athletes represent their respective states at #KIYG2021!"
        />
      </Helmet> */}
      Qualifying Final
    </>
  );
}
